import React, {useState, useRef, useEffect} from "react";
import { TextField, Box, useTheme } from "@mui/material";

export const CodeInput = ({ length = 6, onComplete, autoFocus = false, margin = "normal", ...rest }) => {
    const [values, setValues] = useState(Array(length).fill(""));
    const inputs = useRef([]);
    const theme = useTheme();

    useEffect(() => {
        if (autoFocus && inputs.current[0]) {
            inputs.current[0].focus();
        }
    }, [autoFocus]);

    const handleChange = (i, val) => {
        if (!/^\d?$/.test(val)) return; // nur eine Ziffer
        const newValues = [...values];
        newValues[i] = val;
        setValues(newValues);

        if (val && i < length - 1) {
            inputs.current[i + 1]?.focus();
        }

        const full = newValues.join("");
        if (full.length === length && !newValues.includes("")) {
            onComplete(full);
        }
    };

    const handleKeyDown = (e, i) => {
        if (e.key === "Backspace") {
            if (values[i]) {
                const newValues = [...values];
                newValues[i] = "";
                setValues(newValues);
            } else if (i > 0) {
                inputs.current[i - 1]?.focus();
            }
        }
    };

    const handlePaste = (e) => {
        const pasted = e.clipboardData.getData("text").replace(/\D/g, "");
        if (!pasted) return;

        const newValues = [...values];
        pasted.slice(0, length).split("").forEach((char, i) => {
            newValues[i] = char;
        });

        setValues(newValues);
        inputs.current[Math.min(pasted.length, length) - 1]?.focus();

        if (pasted.length >= length) {
            onComplete(pasted.slice(0, length));
        }

        e.preventDefault();
    };

    return (
        <Box display="flex"
             flexWrap="wrap"
             justifyContent="center"
             columnGap={2}
             rowGap={2}
             maxWidth="100%"
             px={2}
             onPaste={handlePaste}
        >
            {values.map((val, i) => (
                <TextField
                    key={i}
                    margin={margin}
                    {...rest}
                    inputRef={(el) => (inputs.current[i] = el)}
                    value={val}
                    onChange={(e) => handleChange(i, e.target.value)}
                    onKeyDown={(e) => handleKeyDown(e, i)}
                    inputProps={{
                        maxLength: 1,
                        inputMode: "numeric",
                        style: {
                            textAlign: "center",
                            fontSize: "1.8rem",
                            padding: "10px",
                            width: "3rem",
                            maxWidth: "16vw",   // ⚠️ auf kleinen Bildschirmen schrumpfbar
                            height: "3.5rem",
                            borderRadius: theme.shape.borderRadius,
                        },
                    }}
                    variant="outlined"
                />
            ))}
        </Box>
    );
};
